import { css, Global } from '@emotion/react';
import { theme, GlobalStyle as RMGlobalStyle } from '@revenuemarket/design';
import { isClient } from '@revenuemarket/utils';

const GlobalStyle = () => {
  if (!isClient()) return null;

  return (
    <Global
      styles={[
        RMGlobalStyle,
        css`
          * {
            -webkit-user-select: none; /* Safari */
            -moz-user-select: none; /* Firefox */
            -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Standard */
          }

          body {
            background: ${theme.colors.grayscale100};
          }

          *::-webkit-scrollbar {
            width: 14px;
            @media (max-width: 768px) {
              width: 0px;
            }
            height: 14px;
          }

          *::-webkit-scrollbar-track {
            background: none;
          }

          *::-webkit-scrollbar-thumb {
            background-color: rgba(0, 0, 0, 0.2);
            border-radius: 10px;
            background-clip: padding-box;
            border: 3px solid transparent;
          }

          *::-webkit-scrollbar-thumb:hover {
            background-color: rgba(0, 0, 0, 0.1);
          }

          *::-webkit-scrollbar-corner {
            background: none;
          }
        `,
      ]}
    />
  );
};

export default GlobalStyle;
